import { Injectable } from '@angular/core';
import { Gtag } from 'angular-gtag';

@Injectable({
  providedIn: 'root',
})
export class GoogleAnalytics {
  constructor(private gtag: Gtag) {}
  addGA(eventName: string, method: string, category: string, label: string) {
    this.gtag.event(eventName, {
      method: method,
      event_category: category,
      event_label: label,
    });
  }
}
